
import { Navigate, useParams } from 'react-router-dom';

const gamedayRedirectMap: Record<string, string> = {
	WRHSVFB: '/program/online/2F05F946-4E5D-4FFE-AA77-E4D8F3A1425F',
};

export function TinyRedirect() {
	const { slug, teamCode } = useParams<{ slug: string; teamCode: string }>();

	if (slug && slug.toUpperCase() === 'GAMEDAY' && teamCode) {
		const target = gamedayRedirectMap[teamCode.toUpperCase()];

		if (!target) {
			return <div style={{ padding: 20 }}>This link is no longer valid.</div>;
		}

		
		return <Navigate to={target} replace />;
	}
  else{
    return <div style={{ padding: 20 }}>This link is not valid.</div>;
  }
}
